import React from 'react'
import LocationSvg from './location-svg'
import MarkdownWrapper from '../utils/markdown-wrapper'

const LocationCarouselTile = ({ location, handleStoryClick }) => {
    return (
        <div className={`location-box-carousel location-${location.displayOrder}`} onClick={handleStoryClick}>
            <div className="location-image">
                <LocationSvg location={location} />
                <div className="background">
                    <img src={location.dashboardImage?.url} alt={location.dashboardImage?.alt} />
                </div>
            </div>
            <div className="location-description">
                <div className="location-name">
                    <span>{location.title}</span>
                </div>
                { location.established &&
                    <div className="location-year">
                        Established: { location.established}
                    </div>
                }
                <div className="overview">
                    <MarkdownWrapper content={location.overview} />
                </div>
            </div>
        </div>
    )
}

export default LocationCarouselTile
